<template>
  <div>
    <div
      v-if="selectedItem"
      class="grtid-menu-header"
      :style="{ color: fontColor }"
    >
      <button @click="selectedItem = null" class="back">
        <span class="dbc-icon dbc-icon-arrow-left"></span>
        <span>Back</span>
      </button>
      <h3 class="title">{{ selectedItem.text }}</h3>
    </div>
    <grid-items :items="!selectedItem ? items : selectedItem.children" @onClick="onItemClick" @onSelect="onItemSelect($event)" :iconColor="iconColor" :fontColor="fontColor">
    </grid-items>
  </div>
</template>

<script>
import GridMenuItems from './grid-menu-items.component.vue'
export default {
  name: 'GridMenu',
  components: {
    'grid-items': GridMenuItems
  },
  props: {
    items: {
      required: true,
      default: []
    },
    iconColor: {
      type: String
    },
    fontColor: {
      type: String
    }
  },
  methods: {
    onItemClick (item) {
      this.selectedItem = null
      this.$emit('onClick', item)
    },
    onItemSelect (data) {
      data.event.stopPropagation()
      this.selectedItem =
          this.selectedItem && this.selectedItem.id === data.data.id ? null : data.data
    }
  },
  data () {
    return {
      selectedItem: null
    }
  }
}
</script>

<style scoped>
.back {
  border: transparent;
  background: transparent;
  padding: 0;
  margin: 0;
  color: inherit;
}
.back > .dbc-icon {
  margin-right: 10px;
  font-size: 1.2em;
  padding: 0;
}


.grtid-menu-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 5% 5% 0 5%;
}
.grtid-menu-header > .title {
  color: inherit;
  margin: 0;
  padding: 0;
  font-size: 0.8em;
}
</style>



// WEBPACK FOOTER //
// grid-menu-component.vue?39eb59e6